<div class="input-group">
  <input
    [class]="inputClass + ' money-input-amount'"
    type="text"
    inputmode="decimal"
    [placeholder]="placeholder"
    [disabled]="isDisabled"
    [value]="displayAmount"
    (input)="onAmountInput($any($event.target).value)"
    (blur)="markTouched()"
  />
  <select
    *ngIf="showCurrency"
    [class]="selectClass + ' money-input-currency'"
    [disabled]="isCurrencyDisabled"
    [value]="currencyIso"
    (change)="onCurrencyChange($any($event.target).value)"
    (blur)="markTouched()"
  >
    <option *ngFor="let currency of currencyOptions" [value]="currency.code" [disabled]="currency.active === false">{{ currency.code }}</option>
  </select>
</div>
